import { Navigate } from 'react-router-dom';

/**
 * Admin landing page: redirects to the Users management page.
 * Other admin sections (Risk, Organizations, System) have their own routes.
 */
export function AdminPage() {
  return <Navigate to="/organization/users" replace />;
}
